import { render, staticRenderFns } from "./AgencyClientDetails.vue?vue&type=template&id=0e43b415&"
import script from "./AgencyClientDetails.vue?vue&type=script&lang=js&"
export * from "./AgencyClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports